import React from 'react';
import { useState, useEffect } from "react";
import { MdAdd, MdRemove } from "react-icons/md";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import faqImg from '../../../assets/images/faq.jpg'

function Faq() {
    const [isLoading, setIsLoading] = useState(true);
    
    // faq
    const [activeIndex, setActiveIndex] = useState(null);
  
    const toggleFaq = (index) => {
      setActiveIndex(activeIndex === index ? null : index);
    };


    useEffect(() => {
        setIsLoading(false);
    }, []);

    return (
        <>
            <section id="faq">
                <div className="container">
                    <div className="faqMain">
                        <div className="faqCol1">
                            <h2 className="title">Frequently Asked Question</h2>
                            <div className="faqList">
                                <div className={`faqBox ${activeIndex === 0 ? "active" : ""}`} onClick={() => toggleFaq(0)} >
                                    <div className="faqBoxHead">
                                        <h3>What services does Kerala Plots offer?</h3>
                                        <div className="faqBoxHeadIcon">
                                            {activeIndex === 0 ? <MdRemove /> : <MdAdd />}
                                        </div>
                                    </div>
                                    <div className="faqBoxBody" style={{ maxHeight: activeIndex === 0 ? "500px" : "0" }}>
                                        <div className="faqBoxBodyMain">
                                            <p>We specialize in buying, selling, and leasing residential, commercial, and agricultural properties across Kerala. We also assist with legal documentation, property valuation, and real estate consulting.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className={`faqBox ${activeIndex === 1 ? "active" : ""}`} onClick={() => toggleFaq(1)} >
                                    <div className="faqBoxHead">
                                        <h3>How can I find properties listed on your website?</h3>
                                        <div className="faqBoxHeadIcon">
                                            {activeIndex === 1 ? <MdRemove /> : <MdAdd />}
                                        </div>
                                    </div>
                                    <div className="faqBoxBody" style={{ maxHeight: activeIndex === 1 ? "500px" : "0" }}>
                                        <div className="faqBoxBodyMain">
                                            <p>You can browse our property listings under the "Properties" section. Use filters such as location, property type, budget, and amenities to refine your search.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className={`faqBox ${activeIndex === 2 ? "active" : ""}`} onClick={() => toggleFaq(2)} >
                                    <div className="faqBoxHead">
                                        <h3>Are site visits arranged for the listed properties?</h3>
                                        <div className="faqBoxHeadIcon">
                                            {activeIndex === 2 ? <MdRemove /> : <MdAdd />}
                                        </div>
                                    </div>
                                    <div className="faqBoxBody" style={{ maxHeight: activeIndex === 2 ? "500px" : "0" }}>
                                        <div className="faqBoxBodyMain">
                                            <p>Yes, we arrange site visits at your convenience. Please contact us or fill out the inquiry form to schedule a visit.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className={`faqBox ${activeIndex === 3 ? "active" : ""}`} onClick={() => toggleFaq(3)} >
                                    <div className="faqBoxHead">
                                        <h3>Does Kerala Plots help with property loans?</h3>
                                        <div className="faqBoxHeadIcon">
                                            {activeIndex === 3 ? <MdRemove /> : <MdAdd />}
                                        </div>
                                    </div>
                                    <div className="faqBoxBody" style={{ maxHeight: activeIndex === 3 ? "500px" : "0" }}>
                                        <div className="faqBoxBodyMain">
                                            <p>Yes, we offer assistance in connecting you with trusted financial institutions for home loans or other property-related financing.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className={`faqBox ${activeIndex === 4 ? "active" : ""}`} onClick={() => toggleFaq(4)} >
                                    <div className="faqBoxHead">
                                        <h3>How do I list my property on your website?</h3>
                                        <div className="faqBoxHeadIcon">
                                            {activeIndex === 4 ? <MdRemove /> : <MdAdd />}
                                        </div>
                                    </div>
                                    <div className="faqBoxBody" style={{ maxHeight: activeIndex === 4 ? "500px" : "0" }}>
                                        <div className="faqBoxBodyMain">
                                            <p>You can list your property by filling out the "List Your Property" form available on the website. Our team will review your submission and contact you for further details.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="faqCol2">
                            <p>KeralaPlots, your No.1 property dealer in Kerala! We make buying, selling, or leasing properties hassle free! Our trusted platforms enlist vast properties, we connect sellers with buyers effortlessly and ensure secure transactions. Find your dream property today!</p>
                            {isLoading ? (
                                <div className='SkeletonLoader'>
                                    <Skeleton />
                                </div>
                            ) : (
                                <>
                                <div className="faqThumbnail">
                                    <img src={faqImg} alt="" />
                                </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Faq;
